import $ from "jquery";

$(document).ready(() => {
  $(".scf_large-banner-scroll").on("click", function(e) {
    e.preventDefault();
    $("html, body").animate(
      {
        scrollTop: $(this)
          .parent()
          .height(),
      },
      500,
      "linear"
    );
  });

  let topOfDivScroll = 0;
  if ($(".scf_large-banner-scroll").offset()) {
    topOfDivScroll = $(".scf_large-banner-scroll").offset().top * 0.8;
  }
  let windowsize = $(window).innerWidth();

  $(window).resize(function() {
    windowsize = $(window).innerWidth();
  });

  $(window).scroll(function() {
    if (windowsize > 768) {
      if ($(window).scrollTop() > topOfDivScroll) {
        $(".scf_large-banner-scroll").hide();
      } else $(".scf_large-banner-scroll").show();
    }
  });
});



// WEBPACK FOOTER //
// ./client/src/core/components/banner-scroll/index.js